export function fallbackTypeMiddleware({ getState }) {
    return (nextMiddleWare) => (action) => {
        if (!action.type) {
            action.type = "AKUAKU_UNKNOWN_ACTION_TYPE";
        }
        let returnValue = nextMiddleWare(action);
        return returnValue;
    };
}
